import {
  Input,
  Modal,
  ReactSelect,
  TextArea,
  Typography,
  Button,
  Icon,
} from "@anchor/react-components/dist/lib/components";
import React, { useEffect, useState } from "react";

import Select from "react-select";

import { JiraProjectServices } from "../../services/jiraServices";
import { debounce, set } from "lodash";
import { FetchUserProfileService } from "../../services/fetchUserProfileService";
import { formatProfiles } from "../Collaborators/helpers/formatProfiles";
import { MacDataServices } from "../../services/macDataServices";
import { postmortemApiEndpoint } from "../../config";
import errorNotification from "../Notification/errorNotification";
import successNotification from "../Notification/successNotification";
import uploadInitiatedNotification from "../Notification/uploadInitiatedNotification";
import { ACTION_CATEGORIES, HORIZONTAL_VERTICAL_FIX_OPTIONS } from "../../constants/actionCategories";

const initialState = {
  id: "",
  key: "",
  label: "",
  value: "",
};

const initialLoadingAndErrorStates = {
  projects: false,
  issues: false,
  epic: false,
  assignee: false,
  portfolios: false,
  reporter: false,
};

const formatProjects = (data) =>
  data.map((project) => ({
    id: project.id,
    key: project.key,
    label: project.name,
    value: project.name,
    img: project.avatarUrls["48x48"],
  }));

function JiraCreateModal({
  handleModal,
  modalOpen,
  handleJiraStoreModal,
  setCurrentJiraTickets,

  currentJiraTickets,
  saveInContenxt,
}) {
  const [selectedValues, setSelectedValues] = useState({
    project: { ...initialState },
    issue: { ...initialState },
    epic: { ...initialState },
    assignee: { ...initialState },
    summary: "",
    description: "",
    assignee_jira_account_id: "",
    portfolio: { id: "", label: "", value: "" },
    dueDate: "",
    reporter: { ...initialState },
    reporter_jira_account_id: "",
    actionCategory: [],
    horizontalVerticalFix: null,
    platform: { id: "", label: "", value: "" },
    product: { id: "", label: "", value: "" },
  });

  const [recentProjects, setRecentProjects] = useState([initialState]);
  const [projects, setProjects] = useState([initialState]);
  const [portfolios, setPortfolios] = useState([initialState]);
  const [platforms, setPlatforms] = useState([initialState]);
  const [products, setProducts] = useState([initialState]);
  const [loadingPlatforms, setLoadingPlatforms] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [projectsToSearch, setProjectsToSearch] = useState([initialState]);
  const [issues, setIssues] = useState([initialState]);
  const [parents, setParents] = useState([initialState]);
  const [assignees, setAssignees] = useState([initialState]);
  const [reporters, setReporters] = useState([initialState]);
  const [loadingStates, setLoadingStates] = useState(initialLoadingAndErrorStates);
  const [errorStates, setErrorStates] = useState(initialLoadingAndErrorStates)
  const [projectToSearch, setProjectToSearch] = useState("");

  const {
    getJiraProjectService,
    getProjectToSearchJiraService,
    getIssueTypesBasedOnProject,
    getParentsBasedOnIssues,
    jiraAccountId,
    jiraTicketCreate,
  } = JiraProjectServices();

  const { fetchPortfolioData, fetchPlatformData, fetchProductData } = MacDataServices();
  const { fetchUserProfile } = FetchUserProfileService();

  const handleProjectToSearch = (query) => {
    if (!query) {
      setProjects(recentProjects);
      return;
    }
    setProjectToSearch(query);
  };

  const handleJiraTicketInfoChange = (e, key) => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [key]: e,
    }));
  };

  useEffect(() => {
    const fetchProjectsToSearch = debounce(async (query) => {
      if (query) {
        try {
          setLoadingStates((prevStates) => ({ ...prevStates, projects: true }));
          setErrorStates((prevStates) => ({ ...prevStates, projects: false }));
          const data = await getProjectToSearchJiraService(query);
          const formattedProjects = formatProjects(data.values);
          setProjectsToSearch(formattedProjects);
          setProjects(formattedProjects);
          setIssues([initialState]);
          setParents([initialState]);
        } catch (error) {
          console.error("ERROR", error);
          setErrorStates((prevStates) => ({ ...prevStates, projects: true }));
        } finally {
          setLoadingStates((prevStates) => ({
            ...prevStates,
            projects: false,
          }));
        }
      }
    }, 500);

    fetchProjectsToSearch(projectToSearch);
    return () => fetchProjectsToSearch.cancel();
  }, [projectToSearch]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {

        setLoadingStates((prevStates) => ({ ...prevStates, projects: true }));
        setErrorStates((prevStates) => ({ ...prevStates, projects: false }));
        const data = await getJiraProjectService();
        const formattedProjects = formatProjects(data);
        setRecentProjects(formattedProjects);
        setProjects(formattedProjects);
      } catch (error) {
        setErrorStates((prevStates) => ({ ...prevStates, projects: true }));
        console.error("ERROR", error);
      } finally {
        setLoadingStates((prevStates) => ({ ...prevStates, projects: false }));
      }
    };

    const fetchPortfolios = async () => {
      try {
        setLoadingStates((prevStates) => ({ ...prevStates, portfolios: true }));
        setErrorStates((prevStates) => ({ ...prevStates, portfolios: false }));
        const data = await fetchPortfolioData(postmortemApiEndpoint);
        const formattedPortfolios = data.map((portfolio) => ({
          id: portfolio.portfolioId,
          label: portfolio.portfolioName,
          value: portfolio.portfolioName,
        }));
        setPortfolios(formattedPortfolios);
      } catch (error) {
        setErrorStates((prevStates) => ({ ...prevStates, portfolios: true }));
        console.error("ERROR", error);
      } finally {
        setLoadingStates((prevStates) => ({
          ...prevStates,
          portfolios: false,
        }));
      }
    };

    if (modalOpen) {
      fetchProjects();
      fetchPortfolios();
    }
  }, [modalOpen]);

  // Fetch platforms when portfolio is selected
  useEffect(() => {
    if (selectedValues.portfolio?.id) {
      const fetchPlatforms = async () => {
        setLoadingPlatforms(true);
        try {
          const platformsData = await fetchPlatformData(postmortemApiEndpoint, selectedValues.portfolio.id);
          const formattedPlatforms = platformsData.map(platform => ({
            id: platform.platformId,
            label: platform.platformName,
            value: platform.platformName
          }));
          setPlatforms(formattedPlatforms);
        } catch (error) {
          console.error("Error fetching platforms:", error);
          setPlatforms([initialState]);
        } finally {
          setLoadingPlatforms(false);
        }
      };
      fetchPlatforms();
    } else {
      setPlatforms([initialState]);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        platform: { id: "", label: "", value: "" },
      }));
    }
  }, [selectedValues.portfolio]);

  // Fetch products when platform is selected
  useEffect(() => {
    if (selectedValues.platform?.id) {
      const fetchProducts = async () => {
        setLoadingProducts(true);
        try {
          const productsData = await fetchProductData(postmortemApiEndpoint, selectedValues.platform.id);
          const formattedProducts = productsData.map(product => ({
            id: product.id,
            label: product.label,
            value: product.value
          }));
          setProducts(formattedProducts);
        } catch (error) {
          console.error("Error fetching products:", error);
          setProducts([initialState]);
        } finally {
          setLoadingProducts(false);
        }
      };
      fetchProducts();
    } else {
      setProducts([initialState]);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        product: { id: "", label: "", value: "" },
      }));
    }
  }, [selectedValues.platform]);

  useEffect(() => {
    if (!selectedValues.project) {
      setIssues([]);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        issue: { ...initialState },
      }));
      return;
    }
    if (!selectedValues.project.value) {
      setIssues([]);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        issue: { ...initialState },
      }));
      return;
    }

    const fetchIssueTypes = async () => {
      try {
        setLoadingStates((prevStates) => ({ ...prevStates, issues: true }));
        setErrorStates((prevStates) => ({ ...prevStates, issues: false }));
        const data = await getIssueTypesBasedOnProject(
          selectedValues.project.id
        );
        const formattedIssues = data.issueTypes.map((issue) => ({
          id: issue.id,
          key: issue.id,
          label: issue.name,
          value: issue.name,
          img: issue.iconUrl,
        }));
        setIssues(formattedIssues);
        setParents([]);
      } catch (error) {
        setErrorStates((prevStates) => ({ ...prevStates, issues: true }));
        console.error("ERROR", error);
      } finally {
        setLoadingStates((prevStates) => ({ ...prevStates, issues: false }));
      }
    };

    fetchIssueTypes();
  }, [selectedValues.project]);

  useEffect(() => {
    if (!selectedValues.issue) {
      setParents([]);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        parent: { ...initialState },
      }));
      return;
    }
    if (!selectedValues.issue.value) {
      setParents([]);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        parent: { ...initialState },
      }));
      return;
    }

    const fetchParents = async () => {
      try {
        setLoadingStates((prevStates) => ({ ...prevStates, parent: true }));
        setErrorStates((prevStates) => ({ ...prevStates, parent: false }));
        const data = await getParentsBasedOnIssues(
          selectedValues.issue.label,
          selectedValues.project.label
        );

        const parentMap = new Map();
        const formattedParents = data.issues
          .filter((issue) => issue.fields?.parent)
          .filter((issue) => {
            if (parentMap.has(issue.fields.parent.id)) {
              return false;
            } else {
              parentMap.set(issue.fields.parent.id, true);
              return true;
            }
          })
          .map((issue) => ({
            id: issue.fields.parent.id,
            key: issue.fields.parent.id,
            label: `${issue.fields.parent.fields.summary}-${issue.fields.parent.key}`,
            value: issue.fields.parent.id,
            img: issue.fields.parent.fields.issuetype.iconUrl,
          }));
        setParents(formattedParents);
      } catch (error) {
        setErrorStates((prevStates) => ({ ...prevStates, parent: true }));
        console.error("ERROR", error);
      } finally {
        setLoadingStates((prevStates) => ({ ...prevStates, parent: false }));
      }
    };

    fetchParents();
  }, [selectedValues.issue]);

  const getUserProfiles = debounce(async (event) => {
    if (event) {
      setLoadingStates((prevStates) => ({ ...prevStates, assignee: true }));
      setErrorStates((prevStates) => ({ ...prevStates, assignee: false }));
      try {
        const profiles = await fetchUserProfile(event);
        const formattedProfiles = formatProfiles(profiles.value);
        setAssignees(formattedProfiles);
      } catch (error) {
        console.error("Error:", error);
        setErrorStates((prevStates) => ({ ...prevStates, assignee: true }));
      } finally {
        setLoadingStates((prevStates) => ({ ...prevStates, assignee: false }));
      }
    } else {
      setAssignees([]);
    }
  }, 500);

  const getReporterUserProfiles = debounce(async (event) => {
    if (event) {
      setLoadingStates((prevStates) => ({ ...prevStates, reporter: true }));
      setErrorStates((prevStates) => ({ ...prevStates, reporter: false }));
      try {
        const profiles = await fetchUserProfile(event);
        const formattedProfiles = formatProfiles(profiles.value);
        setReporters(formattedProfiles);
      } catch (error) {
        setErrorStates((prevStates) => ({ ...prevStates, reporter: true }));
        console.error("Error:", error);
      } finally {
        setLoadingStates((prevStates) => ({ ...prevStates, reporter: false }));
      }
    } else {
      setReporters([]);
    }
  }, 500);

  useEffect(() => {
    return () => {
      getUserProfiles.cancel();
    };
  }, []);

  useEffect(() => {
    if (!selectedValues.assignee || !selectedValues.assignee.value) return;

    const fetchJiraAccountID = async () => {
      try {
        const accountID = await jiraAccountId(selectedValues.assignee.value);
        setSelectedValues((prevValues) => ({
          ...prevValues,
          assignee_jira_account_id: accountID,
        }));
      } catch (error) {
        console.error("ERROR", error);
      }
    };

    fetchJiraAccountID();
  }, [selectedValues.assignee]);

  useEffect(() => {
    if (!selectedValues.reporter || !selectedValues.reporter.value) return;

    const fetchJiraAccountID = async () => {
      try {
        const accountID = await jiraAccountId(selectedValues.reporter.value);
        setSelectedValues((prevValues) => ({
          ...prevValues,
          reporter_jira_account_id: accountID,
        }));
      } catch (error) {
        console.error("ERROR", error);
      }
    };

    fetchJiraAccountID();
  }, [selectedValues.reporter]);

  const inputsAreValidated = (values) => {
    if (
      !(values.project && values.project.value) ||
      !(values.issue && values.issue.value) ||
      !values.summary ||
      !values.description ||
      !(values.assignee && values.assignee.value) ||
      !(values.reporter && values.reporter.value) ||
      !values.dueDate || 
      !(values.portfolio && values.portfolio.value)
    ) {
      return false;
    }
    return true;
  };

  const createJiraTicket = async () => {
    if (inputsAreValidated(selectedValues)) {
      try {
        uploadInitiatedNotification("Creating Jira Ticket, Please wait...");
        let data = await jiraTicketCreate(selectedValues);

       
        setCurrentJiraTickets((currentJiraTickets) => {
          const updatedJiraTickets = [
            ...currentJiraTickets,
            {
              jiraid: [data.key],
              status: "Todo",
              assignee: selectedValues.assignee.label,
              owners: [selectedValues.reporter.label].filter(
                (item) => item !== undefined
              ),
              description: selectedValues.description,
              duedate: selectedValues.dueDate,
              platformPortfolio: selectedValues.portfolio.value,
              actionCategory: selectedValues.actionCategory || [],
              horizontalVerticalFix: selectedValues.horizontalVerticalFix || null,
              jiraPlatform: selectedValues.platform?.value || null,
              jiraProduct: selectedValues.product?.value || null,
            },
          ];
        
          saveInContenxt(updatedJiraTickets);
          return updatedJiraTickets;
        });
        // saveInContenxt()

        successNotification("Jira Ticket created successfully");
        // uploadInitiatedNotification("Click on save button to save the changes");
        handleModal();

      } catch (error) {
        errorNotification("Error creating Jira Ticket");
        console.error("ERROR", error);
      }
    } else {
      errorNotification("Please fill all the fields");
    }
  };


  const customSingleValue = ({ data }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {data.img && (
        <img
          src={data.img}
          alt={data.label}
          style={{ width: 20, height: 20, borderRadius: "50%" }}
        />
      )}
      {data.label}
    </div>
  );

  // Custom dropdown option with image
  const customOption = (props) => {
    const { data, innerRef, innerProps } = props;
    if (data)
      return (
        <div
          ref={innerRef}
          {...innerProps}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            paddingLeft: "10px",
          }}
        >
          {data.img && (
            <img
              src={data.img}
              alt={data.label}
              style={{ width: 20, height: 20, borderRadius: "50%" }}
            />
          )}

          {data.label}
        </div>
      );

    return <div></div>;
  };

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 100000 }),
  };

  return (
    <div>
      <Modal
        // className="jira-modal"
        width="800"
        height={"700"}
        max-height="200"
        // max-width="800"
        // max-height="1200"
        backdropcloseactiondisabled={true}
        actions={{
          primaryAction: (
            <Button
              label="Create"
              onClick={createJiraTicket}
              appearance="alt"
            />
          ),
          secondaryAction: (
            <Button label="Back" onClick={handleModal} variant="outlined" />
          ),
        }}
        heading=<Typography
          variant="h2"
          fontStyle="bold"
          style={{ fontSize: "30px", textAlign: "center" }}
        >
          Jira Ticket
        </Typography>
        onClose={handleModal}
        showCloseIcon={false}
        open={modalOpen}
      >
        {/* <div style={{width: "33%" }}> */}

        <div style={{}}>
          {/* <input list="fruits" placeholder="Type to search..." />
          <datalist id="fruits">
            {projects.map((project) => (
              <option value={project.value}>
                {console.log("PROJECT", project)}
                <img src={project.img} alt={project.label} />
                <span>{project.label}</span>
              </option>
            ))}
          </datalist> */}

          <div>
            <label style={{ margin: 0 }}>
              <strong>Portfolio</strong>
            </label>

            <Select
              options={portfolios}
              components={{
                SingleValue: customSingleValue,
                Option: customOption,
              }}
              placeholder="Select a portfolio"
              onChange={(e) => handleJiraTicketInfoChange(e, "portfolio")}
              value={
                selectedValues.portfolio?.label ? selectedValues.portfolio : ""
              }
              onInputChange={(e) => getUserProfiles(e)}
              isClearable
              isSearchable
              isMulti={false}
              isLoading={loadingStates.portfolios}
              loadingMessage={() => "Loading Portfolios"}
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>

          <div style={{ marginTop: "10px" }}>
            <label style={{ margin: 0 }}>
              <strong>Platform</strong>
            </label>

            <Select
              options={platforms}
              components={{
                SingleValue: customSingleValue,
                Option: customOption,
              }}
              placeholder="Select a platform"
              onChange={(e) => handleJiraTicketInfoChange(e, "platform")}
              value={
                selectedValues.platform?.label ? selectedValues.platform : ""
              }
              isClearable
              isSearchable
              isMulti={false}
              isLoading={loadingPlatforms}
              loadingMessage={() => "Loading Platforms"}
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              isDisabled={!selectedValues.portfolio?.id}
            />
          </div>

          <div style={{ marginTop: "10px" }}>
            <label style={{ margin: 0 }}>
              <strong>Product</strong>
            </label>

            <Select
              options={products}
              components={{
                SingleValue: customSingleValue,
                Option: customOption,
              }}
              placeholder="Select a product"
              onChange={(e) => handleJiraTicketInfoChange(e, "product")}
              value={
                selectedValues.product?.label ? selectedValues.product : ""
              }
              isClearable
              isSearchable
              isMulti={false}
              isLoading={loadingProducts}
              loadingMessage={() => "Loading Products"}
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              isDisabled={!selectedValues.platform?.id}
            />
          </div>

          <div
            style={{
              display: "grid",
              flexDirection: "row",
              justifyContent: "center",
              gap: "20px",
              gridTemplateColumns: "1fr 1fr",
              marginTop: "10px",
            }}
          >
            <div>
              <label style={{ margin: 0 }}>
                <strong>Projects</strong>
              </label>

              <Select
                options={projects}
                components={{
                  SingleValue: customSingleValue,
                  Option: customOption,
                }}
                placeholder="Select a project"
                onChange={(e) => handleJiraTicketInfoChange(e, "project")}
                value={
                  selectedValues.project?.label ? selectedValues.project : ""
                }
                onInputChange={(e) => handleProjectToSearch(e)}
                isClearable
                isMulti={false}
                isLoading={loadingStates.projects}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div>
              <label style={{ margin: 0 }}>
                <strong>Issue</strong>
              </label>

              <Select
                options={issues}
                components={{
                  SingleValue: customSingleValue,
                  Option: customOption,
                }}
                placeholder="Select an issue"
                onChange={(e) => handleJiraTicketInfoChange(e, "issue")}
                value={selectedValues.issue?.label ? selectedValues.issue : ""}
                onInputChange={(e) => handleProjectToSearch(e)}
                isClearable
                isSearchable={false}
                isMulti={false}
                isLoading={loadingStates.issues}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>
          <div
            style={{
              display: "grid",
              flexDirection: "row",
              justifyContent: "center",
              gap: "20px",
              gridTemplateColumns: "1fr 1fr",
              marginTop: "10px",
            }}
          >
            <div>
              <label style={{ margin: 0 }}>
                <strong>Parent</strong>
              </label>

              <Select
                options={parents}
                components={{
                  SingleValue: customSingleValue,
                  Option: customOption,
                }}
                placeholder="Select a parent"
                onChange={(e) => handleJiraTicketInfoChange(e, "parent")}
                value={
                  selectedValues.parent?.label ? selectedValues.parent : ""
                }
                onInputChange={(e) => console.log(e)}
                isClearable
                isSearchable
                isMulti={false}
                isLoading={loadingStates.parent}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div>
              <label style={{ margin: 0 }}>
                <strong>Due Date</strong>
              </label>

              <Input
                onChange={(e) => {
                  // setError(false);
                  handleJiraTicketInfoChange(e.target.value, "dueDate");
                }}
                value={selectedValues.dueDate}
                placeholder="Due Date"
                name="ticket"
                // error={error}
                // errorMessage="Invalid Jira Ticket"
                type="date"
                
              />
            </div>
          </div>

          <div
            style={{
              display: "grid",

              justifyContent: "center",
              gap: "20px",
              gridTemplateColumns: "1fr 1fr",
              marginTop: "10px",
            }}
          >
            <div>
              <label style={{ margin: 0 }}>
                <strong>Owner</strong>
              </label>

              <Select
                options={
                  reporters ? reporters : [{ id: "", label: "", value: "" }]
                }
                components={{
                  SingleValue: customSingleValue,
                  Option: customOption,
                }}
                placeholder="Enter Reporter's name"
                onChange={(e) => handleJiraTicketInfoChange(e, "reporter")}
                value={
                  selectedValues.reporter?.label ? selectedValues.reporter : ""
                }
                onInputChange={(e) => getReporterUserProfiles(e)}
                isClearable
                isSearchable
                isMulti={false}
                isLoading={loadingStates.reporter}
                styles={customStyles}
                noOptionsMessage={() => "No users found"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div>
              <label style={{ margin: 0 }}>
                <strong>Assignee</strong>
              </label>

              <Select
                options={
                  assignees ? assignees : [{ id: "", label: "", value: "" }]
                }
                components={{
                  SingleValue: customSingleValue,
                  Option: customOption,
                }}
                placeholder="Enter Assignee's name"
                onChange={(e) => handleJiraTicketInfoChange(e, "assignee")}
                value={
                  selectedValues.assignee?.label ? selectedValues.assignee : ""
                }
                onInputChange={(e) => getUserProfiles(e)}
                isClearable
                isSearchable
                isMulti={false}
                isLoading={loadingStates.assignee}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                noOptionsMessage={() => "No users found"}
              />
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            <div style={{ marginTop: "10px" }}>
              <label style={{ margin: 0 }}>
                <strong>Summary</strong>
              </label>

              <Input
                onChange={(e) => {
                  // setError(false);
                  handleJiraTicketInfoChange(e.target.value, "summary");
                }}
                value={selectedValues.summary}
                placeholder="Summary"
                name="ticket"
                // error={error}
                // errorMessage="Invalid Jira Ticket"
                type="string"
                // loadingMessage={"Loading Ticket"}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              <label style={{ margin: 0 }}>
                <strong>Description</strong>
              </label>

              <TextArea
                value={selectedValues.description}
                onChange={(e) =>
                  handleJiraTicketInfoChange(e.target.value, "description")
                }
                spellCheck={true}
                lang="en"
              />
            </div>

            <div style={{ marginTop: "10px" }}>
              <label style={{ margin: 0 }}>
                <strong>Action Category</strong>
              </label>
              <Select
                options={ACTION_CATEGORIES}
                placeholder="Select action categories"
                onChange={(selected) => {
                  const values = selected ? selected.map(opt => opt.value) : [];
                  handleJiraTicketInfoChange(values, "actionCategory");
                }}
                value={ACTION_CATEGORIES.flatMap(cat => cat.options).filter(opt => 
                  selectedValues.actionCategory?.includes(opt.value)
                )}
                isClearable
                isSearchable
                isMulti={true}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div style={{ marginTop: "10px" }}>
              <label style={{ margin: 0 }}>
                <strong>Horizontal/Vertical Fix</strong>
              </label>
              <Select
                options={HORIZONTAL_VERTICAL_FIX_OPTIONS}
                placeholder="Select fix type"
                onChange={(selected) => {
                  handleJiraTicketInfoChange(selected?.value || null, "horizontalVerticalFix");
                }}
                value={HORIZONTAL_VERTICAL_FIX_OPTIONS.find(opt => 
                  opt.value === selectedValues.horizontalVerticalFix
                )}
                isClearable
                isSearchable
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>
        </div>

        {/* </div> */}
      </Modal>{" "}
    </div>
  );
}

export default JiraCreateModal;
